module.exports = __webpack_public_path__ + "img/pumpStation.ca6be81f.svg";